import { jsx } from "react/jsx-runtime";
import { useInView } from "../../../../hooks/index.js";
import { observedThresholds } from "../utils/observedThresholds.js";
function Canary(props) {
  const { viewport, onChange, rect } = props;
  const { top = 0, left = 0, height = 0, width = 0 } = rect ?? {};
  const { ref } = useInView({
    threshold: observedThresholds,
    root: viewport,
    onChange
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      style: {
        top,
        left,
        width,
        height,
        zIndex: 10,
        position: "absolute",
        visibility: "hidden",
        pointerEvents: "none"
      },
      className: "truncate-list-canary",
      "data-testid": "truncate-list_canary-more"
    }
  );
}
export {
  Canary
};
//# sourceMappingURL=Canary.js.map
